// extracted by mini-css-extract-plugin
module.exports = {"modal":"invalid-token-modal__modal___3ECES","content":"invalid-token-modal__content___6WfDo","message":"invalid-token-modal__message___jyvcV"};